




import { Component, Vue } from 'vue-property-decorator';
import OrgInput from '@/components/form/OrgInput.vue';

@Component({
  components: { OrgInput },
})
export default class DemoOrg extends Vue {
  public mainId: number | null = null;
  public subId: number | null = null;
  public orgCode = 'B000000019';
  public orgName = 'versedeco';

  public created() {
    setTimeout(() => {
      this.mainId = 2;
    }, 1000);

    // setTimeout(() => {
    //   this.subId = 3;
    // }, 5000);
  }
}
